require('./bootstrap');
require('swiper/swiper-bundle');
require('magnific-popup/dist/jquery.magnific-popup');
require('imagesloaded/imagesloaded.pkgd');
require('isotope-layout/dist/isotope.pkgd');
require('aos/dist/aos');
require('waypoints/src/waypoint');
require('jquery.counterup/jquery.counterup.min');
require('appear/dist/appear');
require('./plugins/main');
require('./pages/web-common');
require('./pages/web-login');
require('ion-rangeslider/js/ion.rangeSlider.min');
require('./utilities/assist-modal');
require('./program-list');
require('lazyload/lazyload')
